import { render, staticRenderFns } from "./academic_schdual_refereesystem_net.vue?vue&type=template&id=39c39fc1&scoped=true&"
import script from "./academic_schdual_refereesystem_net.vue?vue&type=script&lang=js&"
export * from "./academic_schdual_refereesystem_net.vue?vue&type=script&lang=js&"
import style0 from "./academic_schdual_refereesystem_net.vue?vue&type=style&index=0&id=39c39fc1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c39fc1",
  null
  
)

export default component.exports